import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { NavBox } from '~/common/nav-box';
import { NavBlock } from '~/common/nav-drawer';
import { UserBar } from '~/features/dashboard/components/user-bar';
import { CalendarPage } from '~/features/dashboard/pages/calendar';
import { Content } from '../components/content';
import { NAV_DRAWER_ITEMS } from '../config';
import { getContactsThunk } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import * as CreatorsListFeature from '~/features/creators-list';
import { Loader } from '~/common/loader';
import { CreatorPreview } from '~/features/dashboard/components/creator-preview';

export const FeatureRouter = () => {
    const [isLoading, setIsLoading] = useState(true);
    const match = useRouteMatch<{ creatorId: string }>();
    const dispatch = useThunkDispatch();
    const route = useAppRoute();

    useEffect(() => {
        if (match.params.creatorId) {
            dispatch(getContactsThunk({ creatorId: Number(match.params.creatorId) }))
                .then(data => {
                    if (data.error) {
                        route(CreatorsListFeature.FEATURE_ROUTER_PATH);
                    }
                })
                .finally(() => setIsLoading(false));
        } else {
            route(CreatorsListFeature.FEATURE_ROUTER_PATH);
        }
    }, [match.params.creatorId, dispatch, route]);

    return isLoading ? (
        <Loader />
    ) : (
        <Content>
            <NavBlock>
                <UserBar />

                {Object.values(NAV_DRAWER_ITEMS).map(props => (
                    <NavBox key={props.title} {...props} />
                ))}

                {/*<SmallCalendar events={events} />*/}
            </NavBlock>

            <Switch>
                {Object.values(NAV_DRAWER_ITEMS).map(({ page, link }) => (
                    <Route key={link} path={`${match.path}${link}`} component={page} />
                ))}
                <Route exact path={`${match.path}/creator-preview`} component={CreatorPreview} />

                <Route path={`${match.path}/calendar`} exact component={CalendarPage} />

                <Redirect to={`${match.url}${NAV_DRAWER_ITEMS.team.link}`} />
            </Switch>
        </Content>
    );
};
